const info={
    ZH: {  //中文翻译
        youhui:"优惠券",
        DLQ:"待领取",
        WSY:"未使用",
        SYZ:"使用中",
        YSY:"已使用",
        YGQ:"已过期",
        dizhi:"我的地址",
        dizhis:"收件地址",
        MR:"默认",
        SHEWEI:"设为默认地址",
        bianji:"编辑",
        del:"删除",
        add:"新增收货地址",
        mingzi:"姓名",
        TEL:"电话",
        youxiang:"邮箱",
        HZ:"护照",
        ZS:"州省",
        city:"城市",
        xiangxi:"详细地址",
        youzheng:"邮政编码",
        queren:"确认新增",
        baocun:"保存",
        wiliu:"物流查询",
        zaiTU:"在途",
        QS:"签收",
        orders:"订单号",
        Zorders:"转单号",
        guiji:"最新轨迹",
        move:"更多",
        firend:"邀请好友",
        querenxiugai:"确认修改",
        company:"公司名称",
    },  
    EN: {  //英文翻译
        youhui:"coupon",
        DLQ:"unclaimed",
        WSY:"notUsed",
        SYZ:"useing",
        YSY:"Used",
        YGQ:"Expired",
        dizhi:"My address",
        MR:"default",
        SHEWEI:"set default",
        bianji:"edit",
        del:"del",
        add:"Add receiving address",
        dizhis:"Receiving address",
        mingzi:"name",
        TEL:"Telephone",
        youxiang:"mailbox",
        HZ:"passport",
        ZS:"State",
        city:"city",
        xiangxi:"Detailed address",
        youzheng:"Postal Code",
        queren:"Confirm new",
        baocun:"save",
        wiliu:"Logistics query",
        zaiTU:"intransit",
        QS:"SignFor",
        orders:"orderNo",
        Zorders:"TransferOrder",
        guiji:"Latest track",
        move:"more",
        firend:"Invite friends",
        querenxiugai:"Confirm modification",
        company:"consignee_companyname",
        
    }
}
export default info